import { render } from "./RecordEditor.vue?vue&type=template&id=1868b2c8&scoped=true"
import script from "./RecordEditor.vue?vue&type=script&lang=js"
export * from "./RecordEditor.vue?vue&type=script&lang=js"

import "./RecordEditor.vue?vue&type=style&index=0&id=1868b2c8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1868b2c8"]])

export default __exports__